import { Component, ElementRef, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BankAccountListComponent } from './bankaccount-list.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { BankAccountService } from './bankaccount.service';

@Component({
    selector: 'convfact-bankaccountdelete',
    templateUrl: './bankaccount-dialog-delete.component.html',
    styleUrls: ['./bankaccount.component.css'],
    standalone: false
})
export class BankAccountDialogDeleteComponent {
    uid: string = this.data.uid;
    type: string = this.data.type;
    error_msg: string;

    constructor(
        public dialogRef: MatDialogRef<BankAccountListComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public snackBar: MatSnackBar,
        private bankAccountService: BankAccountService
    ) { }

    displayInfo(message: string): void {
        const options = new MatSnackBarConfig();
        options.duration = 10000;
        options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
    }

    delete() {
        /* this.bankAccountService.deleteData(this.uid)
            .then(response => {
                this.displayInfo(response);
                this.closeDialog();
            })
            .catch(errors => {
                this.displayInfo(errors.error['message']);
                this.closeDialog();
            }); */
    }

    closeDialog() {
        this.dialogRef.close();
    }

}
